import { DataLayer } from '@websrc/App/Components/DataLayer'
import { createTrackingProduct } from '@websrc/App/Helpers/adobeTracking'
import { useBasketStateOptional } from '@websrc/Basket/useBasketState'
import { ProductMetaContext } from '@websrc/Basket/useProductMeta'
import { useContext, useEffect } from 'react'

export function DataLayerBasketState() {
  const basketState = useBasketStateOptional()
  const dataLayer = DataLayer._useRawDataLayer()
  const productMetaState = useContext(ProductMetaContext)

  useEffect(() => {
    if (!basketState) {
      dataLayer.products = []

      return
    }

    const paymentType = basketState.meta.payment?.paymentType

    if (paymentType) {
      dataLayer.order_payment_type = paymentType === 'creditCard' ? 'Credit Card' : 'Purchase Order'
    } else {
      dataLayer.order_payment_type = ''
    }

    dataLayer.cart_products = basketState.items
      .map((item) => {
        const meta = productMetaState[`${item.productNumber}`]
        if (!meta) return null
        else return createTrackingProduct(meta, item.quantity, item.unitPrice)
      })
      .filter((p) => p !== null)
  }, [dataLayer, basketState, productMetaState])

  return null
}
